function addGiftPrd(quantity) {

  let formData = { items: [ { id: FoxTheme.settings.giftProduct, quantity: quantity } ] };
  // console.log('Inside Gift function', formData);
  
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => { return response.json()})
    .then( data => {
      console.log('Gift Added', data)
      document.dispatchEvent(new Event('cart:refresh'));
    })
    .catch((error) => { console.error("Gift Addition Error:", error) });
}

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".testimonial-swiper", {
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper_next_button",
      prevEl: ".swiper_prev_button"
    },
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 1
      }
    }
  });

  const buyButtons = document.querySelector('body.product-template .product__block--buy_buttons');
  const body = document.body;
    
  
  function checkButtonVisibility() {
    if (!buyButtons) return;
    const rect = buyButtons.getBoundingClientRect();
    const isVisible = rect.top >= 0;
    
    if (!isVisible) {
        body.classList.add('buy_button_atc_fixed');
    } else {
        body.classList.remove('buy_button_atc_fixed');
    }
  }
  
  checkButtonVisibility();
  
  window.addEventListener('scroll', checkButtonVisibility);

  document.querySelector(".fixed_atc_container")?.addEventListener("click", function () {
    const atcBtn = this.closest(".product").querySelector(".product-form__submit");
    if (atcBtn) {
      atcBtn.click();
    }
  })
})

window.freGift_function = async (cart_items) => {

  try{
    console.log('Free Gift Entered');
    let giftProductId = parseInt(FoxTheme.settings.giftProduct);
    let items = [];
    if(cart_items && cart_items.cartItemProducts){ items = Array.from(cart_items.cartItemProducts) }
    else if (cart_items) { items = Array.from(cart_items.querySelectorAll('ul li.cart-item')) }
    // else{ items = Array.from(cart_items?.querySelectorAll('ul li.cart-item')) }
  
    if(items.length > 0 && giftProductId > 0){
      let item_arr = [];
      let selected_products = FoxTheme.settings.selectedProductsForGift.split(',').map(id => parseInt(id));
      
      items.map( i => {
        let existingItem = item_arr.find(item => item.id === parseInt(i.dataset.variantId));
        if (existingItem) { existingItem.quantity = parseInt(existingItem.quantity) + parseInt(i.dataset.quantity)} 
        else { item_arr.push({ id : parseInt(i.dataset.variantId), quantity : parseInt(i.dataset.quantity)}) }
      })
    
      let selected_prd_qty = item_arr.filter(item => selected_products.includes(item.id)).reduce((sum, item) => sum + item.quantity, 0);
      let giftItem = item_arr.find(item => item.id === giftProductId);
      let giftQuantity = giftItem ? giftItem.quantity : 0;
      let remainingQuantity = selected_prd_qty - giftQuantity;  
      if (remainingQuantity > 0) { addGiftPrd(remainingQuantity) }
      
      // else{ document.dispatchEvent(new Event('cart:refresh')) }
      // window.cartTimer();
      // console.log('item_arr',{ item_arr:item_arr, selected_prd_qty:selected_prd_qty, remainingQuantity:remainingQuantity });
    }
  
    //Single Product Upsell hide/show
    // let cart_single_prd = 9804996772187;
    let cart_single_prd = parseInt(FoxTheme.settings.cart_single_prd);
    let cart_pair_single_prd = parseInt(FoxTheme.settings.cart_pair_single_prd);
    if(cart_single_prd > 0){
      
      let cart_single_prd_added = items.some( i => cart_single_prd == parseInt(i.dataset.prdId));
      let cart_pair_single_prd_added = cart_pair_single_prd > 0 ? items.some( i => cart_pair_single_prd == parseInt(i.dataset.prdId)) : false;
      let is_cart_pair_single_prd = Boolean(cart_pair_single_prd > 0);
      
      console.log({ cart_pair_single_prd_added, is_cart_pair_single_prd });
      let parent = items.length > 0 ? items[0].closest('.drawer__inner') : null;
      let cartElement = document.querySelector('.drawer__inner .cart_single_prd');
  
      // Check if cart_pair_single_prd is valid
  
      if (is_cart_pair_single_prd) {
        if (cart_pair_single_prd_added) { 
          // cartElement?.classList.contains('hidden') ? cartElement?.classList.remove('hidden') : '' 
          if (cart_single_prd_added) { cartElement?.classList.contains('hidden') ? '' : cartElement?.classList.add('hidden') }
          else{ cartElement?.classList.contains('hidden') ? cartElement?.classList.remove('hidden') : '' }
        } 
        else { cartElement?.classList.contains('hidden') ? '' : cartElement?.classList.add('hidden') }
      } else {
        if (cart_single_prd_added) { parent?.querySelector('.cart_single_prd').classList.contains('hidden') ? '' : parent?.querySelector('.cart_single_prd').classList.add('hidden') } 
        else if (items.length > 0 && !cart_single_prd_added) { parent?.querySelector('.cart_single_prd').classList.contains('hidden') ? parent?.querySelector('.cart_single_prd').classList.remove('hidden') : '' } 
        else if (items.length == 0) { cartElement.classList.contains('hidden') ? '' : cartElement.classList.add('hidden') }
      }
    }
    
    let res = await fetch('/cart.js');
    let cartData_res = await res.json();
    let c_item_count = cartData_res.item_count;

    // console.log('c_item_count',c_item_count);

    let cart_parent = document.querySelector('cart-drawer .drawer__inner');
    let cart_badges = cart_parent?.querySelector('.custom_cart_badges--wrapper');
    
    if(cart_parent && cart_badges){
      if(c_item_count > 0){ cart_badges.classList.contains('hidden') ? cart_badges.classList.remove('hidden') : '' }
      else if(c_item_count == 0){ cart_badges.classList.contains('hidden') ? '' : cart_badges.classList.add('hidden') }
    }  
  }
  catch(error){console.error("An error occurred:", error)}
  finally{ 
    // window.cartTimer();
    window.cartUpsellsSlider();
  }
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".cart_item_prpt_header")) {
   e.target.closest(".cart-item__details").classList.toggle("view_more_properties_open")
  }

  if (e.target.closest(".properties_edit_btn")) {
    const cartItem = e.target.closest(".cart-item");
    const cartItemUrl = cartItem.querySelector(".cart-item__title").href;
    const productKey = cartItem.getAttribute('data-product-key-input');
    const cartItemId = cartItem.querySelector('input[name*="[properties][_product_key]"]')?.value;

    sessionStorage.setItem('shouldFireStepFormInit', 'true');
    sessionStorage.setItem('prefillCartItemId', cartItemId);

    // Find all cart items with the same product key and custom properties
    const allCartItems = document.querySelectorAll('.cart-item');
    const bundleItems = [];
    
    allCartItems.forEach(item => {
        const itemProductKey = item.getAttribute('data-product-key-input');
        const isCustomProperty = item.getAttribute('data-property-custom') === 'true';
        
        if (itemProductKey === productKey && isCustomProperty) {
            bundleItems.push(item);
        }
    });

    // Store bundle count
    sessionStorage.setItem("productBundleSelcted", bundleItems.length.toString());

    // Collect data for each bundle
    const bundleData = [];
    
    bundleItems.forEach((item, index) => {
        const cartItemData = {};
        const cartProperties = item.querySelector(".cart_item_properties_conatiner");

        if (cartProperties) {
            const optionRows = cartProperties.querySelectorAll(".flex.gap-1");

            optionRows.forEach(row => {
                const label = row.children[0]?.textContent?.trim().replace(":", "").toLowerCase();
                const value = row.children[1]?.textContent?.trim();

                if (label && value) {
                    cartItemData[label] = value;
                }
            });

            // Store active design image if exists
            const activeDesignImg = item.querySelector('.active_design_img img');
            if (activeDesignImg) {
                cartItemData._active_design_img = activeDesignImg.src;
            }
            
            bundleData.push(cartItemData);
        }
    });

    sessionStorage.setItem("cartItemData", JSON.stringify(bundleData)); 
    window.location.href = cartItemUrl;
  }

  if (e.target.closest("#addToCart")?.closest(".monogram_popup[data-edit-form-id]")) {
    const productKey = sessionStorage.getItem("prefillCartItemId");
    const editCartItem = document.querySelector(`[data-product-key-input="${productKey}"]`);
    editCartItem?.querySelector(".cart-item__remove")?.click();
    sessionStorage.removeItem('prefillCartItemId');
  }
});

window.addEventListener('load', () => {
  if (sessionStorage.getItem('shouldFireStepFormInit') === 'true') {
    sessionStorage.removeItem('shouldFireStepFormInit');
    document.dispatchEvent(new CustomEvent("step_form_edit"));
  }
});

// Check if this is a cart page
if (window.location.pathname.includes('/cart')) {
  sessionStorage.setItem('cart_redirect', 'true');
  window.location.href = window.Shopify.routes.root;
} else if (sessionStorage.getItem('cart_redirect') === 'true') {
  window.addEventListener('load', () => {
    document.querySelector(".header__icons .header__buttons a")?.click();
  });
  sessionStorage.removeItem('cart_redirect');
}

document.querySelectorAll(".swatches li a")?.forEach((element) => {
  element.addEventListener("click", (e) => {
    e.preventDefault();
    
    const variantImage = e.target.dataset.variantImage;
    const productWrapper = e.target.closest(".product-card__wrapper");
    
    if (!productWrapper) return;
    
    const productImage = productWrapper.querySelector(".product-card__image img");
    const secondaryImage = productWrapper.querySelector(".product-card__image.product-card__image--second img");
    
    if (productImage && secondaryImage) {
      productImage.srcset = "";
      secondaryImage.srcset = "";
      productImage.src = secondaryImage.src = variantImage;
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   console.log("📽 Main video control script loaded");

//   // SVG Icons
//   const playIcon = `
//     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Play" class="r-1d3v5cl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: 100%;"><path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"></path></svg>`;

//   const pauseIcon = `
//     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Pause" style="width:var(--rsw, 100%);height:100%" class="r-1d3v5cl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"></path></svg>`;

//   const muteIcon = `
//      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Mute" class="r-lialkd" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%; height: 100%;"><path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"></path><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"></path><path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"></path></svg>`;

//   const unmuteIcon = `
   
//     <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Unmute" style="width:var(--rsw, 100%);height:100%" class="r-lialkd" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"></path></svg>`;

//   function setupVideoControls(video) {
//     const playButton = document.querySelector(".video_play-button");
//     const volumeButton = document.querySelector(".video-volumne_controls");

//     if (!playButton || !volumeButton || !video) {
//       console.warn("❌ Controls or video not found");
//       return;
//     }

//     let isPlaying = false;
//     video.controls = false;
//     video.muted = true;

//     playButton.innerHTML = pauseIcon;
//     volumeButton.innerHTML = unmuteIcon;

//     playButton.addEventListener("click", () => {
//       if (video.paused || video.ended) {
//         video.play();
//         playButton.innerHTML = pauseIcon;
//         isPlaying = true;
//       } else {
//         video.pause();
//         playButton.innerHTML = playIcon;
//         isPlaying = false;
//       }
//     });

//     volumeButton.addEventListener("click", () => {
//       video.muted = !video.muted;
//       volumeButton.innerHTML = video.muted ? unmuteIcon : muteIcon;
//     });

//     // ✅ Auto-play and auto-mute on load
//     playButton.click();
//     console.log("✅ Auto-play triggered");

//     setTimeout(() => {
//       volumeButton.click();
//       console.log("✅ Auto-mute toggled");
//     }, 200);
//   }

//   function waitForElements(callback) {
//     const checkInterval = setInterval(() => {
//       const video = document.querySelector(".video-prd_page");
//       const playBtn = document.querySelector(".video_play-button");
//       const volBtn = document.querySelector(".video-volumne_controls");

//       if (video && playBtn && volBtn) {
//         clearInterval(checkInterval);
//         callback(video);
//       }
//     }, 100);
//   }

//   waitForElements((video) => {
//     setupVideoControls(video);
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  console.log("📽 Video control script loaded");

  // SVG Icons
  const playIcon = `
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Play" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: 100%;">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393"></path>
    </svg>`;

  const pauseIcon = `
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Pause" style="width:var(--rsw, 100%);height:100%" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5"></path>
    </svg>`;

  const muteIcon = `
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Mute" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style="width: var(--rsw, 100%); height: 100%;">
      <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"></path>
      <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"></path>
      <path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"></path>
    </svg>`;

  const unmuteIcon = `
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" role="presentation" aria-label="Unmute" style="width:var(--rsw, 100%);height:100%" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"></path>
    </svg>`;

  function setupVideoControls(section) {
    const video = section.querySelector(".video-prd_page");
    const playButton = section.querySelector(".video_play-button");
    const volumeButton = section.querySelector(".video-volumne_controls");

    if (!video || !playButton || !volumeButton) {
      console.warn("❌ Controls or video not found in section:", section);
      return;
    }

    let isPlaying = false;
    video.controls = false;
    video.muted = true;

    playButton.innerHTML = pauseIcon;
    volumeButton.innerHTML = unmuteIcon;

    playButton.addEventListener("click", () => {
      if (video.paused || video.ended) {
        video.play();
        playButton.innerHTML = pauseIcon;
        isPlaying = true;
      } else {
        video.pause();
        playButton.innerHTML = playIcon;
        isPlaying = false;
      }
    });

    volumeButton.addEventListener("click", () => {
      video.muted = !video.muted;
      volumeButton.innerHTML = video.muted ? unmuteIcon : muteIcon;
    });

    // Auto-play on load
    setTimeout(() => {
      playButton.click();
      setTimeout(() => {
        volumeButton.click(); // toggle mute state
      }, 300);
    }, 100);
  }

  function waitForSectionElements(section) {
    const check = setInterval(() => {
      const video = section.querySelector(".video-prd_page");
      const playBtn = section.querySelector(".video_play-button");
      const volBtn = section.querySelector(".video-volumne_controls");

      if (video && playBtn && volBtn) {
        clearInterval(check);
        setupVideoControls(section);
      }
    }, 100);
  }

  // Loop through all sections
  document.querySelectorAll(".video-with-text").forEach((section) => {
    waitForSectionElements(section);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // console.log("📽 Popup video script loaded");

  const triggers = document.querySelectorAll(".video-size_increse");
  const popup = document.getElementById("video-popup");
  const popupVideo = document.getElementById("popup-video");
  const popupOverlay = document.querySelector(".video-popup-overlay");
  const closeButton = document.querySelector(".popup-close");

  if (!popup || !popupVideo || !popupOverlay || !closeButton) {
    // console.warn("❌ Required popup elements not found.");
    return;
  }

  triggers.forEach((button, index) => {
    button.addEventListener("click", () => {
      const videoContainer = button.closest(".video--full__width");
      if (!videoContainer) return;

      const template = videoContainer.querySelector("template");
      if (!template) return;

      const source = template.content
        ? template.content.querySelector("source")
        : new DOMParser()
            .parseFromString(template.innerHTML, "text/html")
            .querySelector("source");

      const videoSrc = source?.getAttribute("src");
      if (!videoSrc) return;

      popupVideo.src = videoSrc;
      popupVideo.controls = true;
      popupVideo.play();
      popup.classList.remove("hidden");
    });
  });

  function closePopup(reason) {
    // console.log("Closing popup:", reason);
    popupVideo.pause();
    popupVideo.removeAttribute("src");
    popup.classList.add("hidden");
  }

  popup.addEventListener("click", function (event) {
    const target = event.target;
    if (target.classList.contains("video-popup-overlay") || target.id === "popup-video") {
      closePopup("Overlay or video clicked");
    }
  });

  closeButton.addEventListener("click", () => closePopup("Close button clicked"));

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !popup.classList.contains("hidden")) {
      closePopup("Escape key pressed");
    }
  });
});


 function toggleStickyButton() {
    const button = document.querySelector('.button-sticky_on_mobile');
    if (!button) return;

    if (window.scrollY >= 1100) {
      button.classList.add('sticky');
    } else {
      button.classList.remove('sticky');
    }
  }

  // Run only on mobile (≤768px)
  if (window.innerWidth <= 768) {
    window.addEventListener('scroll', toggleStickyButton);
    document.addEventListener('DOMContentLoaded', toggleStickyButton);
  }


// New Product Options addition functionality
window.syncHiddenInput = function(sourceEl, targetSelector) {
  if (!sourceEl || !sourceEl.name) return;

  // console.log(sourceEl,targetSelector);  
  let name = sourceEl.name;
  let value = sourceEl.value;

  // if(!name){ name = sourceEl.dataset.name; value = sourceEl.dataset.value; }

  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  hiddenInput.name = name;
  hiddenInput.value = value;
 
  const target = targetSelector;
  if (!target) return;

  const existing = target.querySelector(`input[type="hidden"][name="${name}"]`);
  if (existing) { target.removeChild(existing) }

  target.appendChild(hiddenInput);
  
  let isSlected = sourceEl.closest('[data-is-selected]').dataset.isSelected;  
  if(isSlected == 'false'){ sourceEl.closest('[data-is-selected]').setAttribute('data-is-selected','true') }

  let name_id = target.querySelector(`input[name="id"]`);
  if(name_id){ name_id.name = 'items[99][id]' }
}


class CustomSelect extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();
    this.isMultiSelect = false;
    this.selName = 'custom-select';
    this.getElement();
    this.addEventListeners();
  }

  getElement() {
    this.selectEl = this.querySelector(".js-select");
    this.optionEls = this.querySelectorAll(".js-option");
    this.selectValueEl = this.querySelector(".js-select-value");
    // this.resetBtn = this.querySelector(".js-reset"); // new reset button
  }

  addEventListeners() {
    this.selectValueEl?.addEventListener("click", this.handleSelectClick.bind(this));
    this.optionEls?.forEach((el) => { el.addEventListener("click", this.handleOptionClick.bind(this, el)) });
    // this.resetBtn?.addEventListener("click", this.resetMultiSelect.bind(this));
  }

  handleSelectClick() {
    this.selectEl?.classList.toggle("open");
  }

  handleOptionClick(item) {
    const name = item.dataset.name;
    const handle = item.dataset.handle;
    const value = item.dataset.value;
    const thumbnail = item.dataset.icon;
    const spanEl = this.selectValueEl.querySelector("span");
    const imgEl = this.selectValueEl.querySelector("img");
    const formTarget = item.closest(".product__blocks")?.querySelector(".product-form form");

    if (!formTarget) { console.warn("target not found in class"); return; }

    const inputName = this.selectValueEl.dataset.name;
    const propName = this.selectValueEl.dataset.propName;

    if (this.isMultiSelect) {
      // Hide image, show reset button, clear placeholder text
      if (imgEl) imgEl.style.display = "none";
      if (this.resetBtn) this.resetBtn.style.display = "inline-block";
      
      if (spanEl.textContent === this.selectValueEl.dataset.placeholder) { spanEl.textContent = "" }

      // Add name if not already in list
      let currentText = spanEl.textContent || "";
      let selectedNames = currentText ? currentText.split(", ") : [];

      // if (!selectedNames.includes(name)) { selectedNames.push(name); spanEl.textContent = selectedNames.join(", "); }
      if (!selectedNames.includes(name)) { selectedNames.push(name); item.classList.add('i--selected'); } 
      else { selectedNames = selectedNames.filter(n => n !== name); item.classList.remove('i--selected'); }
      spanEl.textContent = selectedNames.join(", ");

      if(selectedNames.length == 0){ this.resetMultiSelect(); }

      // Get parent data-p value
      const dataPWrapper = item.closest("[data-p]");
      const dataP = parseInt(dataPWrapper?.getAttribute("data-p")) ;

      // Remove old inputs starting with items[x][id]
      const regex = /^items\[(\d+)\]\[id\]$/;

      if(dataP != 0){
        const existingMultiInputs = formTarget.querySelectorAll(`input[type="hidden"][name^="items["]`);
        // console.log('existingMultiInputs', existingMultiInputs);
        
        existingMultiInputs.forEach((input) => {
          const match = input.name.match(regex);
          if (match && !input.classList.contains('product-variant-id')) {
            const index = parseInt(match[1]);
            if (index >= dataP) { input.remove() }
          }
        });
      }else{
        const existing = formTarget.querySelector(`input[type="hidden"][name="${inputName}"]`);
        if (existing) formTarget.removeChild(existing);
      }

      // Find all selected values in an array
      const allValues = spanEl.textContent.split(", ").map((n) => {
        const match = Array.from(this.optionEls).find((opt) => opt.dataset.name === n);
        return match?.dataset.value || "";
      }).filter(Boolean);

      if(dataP != 0){
        // Append hidden inputs: items[dataP + idx][id]
        allValues.forEach((val, idx) => {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = `items[${dataP + idx}][id]`;
          hiddenInput.value = val;
          hiddenInput.setAttribute("data-generated-by", this.selName );
          formTarget.appendChild(hiddenInput);
        });
      }else{
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = inputName;
        hiddenInput.value = selectedNames.join(", ");
        hiddenInput.setAttribute("data-generated-by", this.selName );
        formTarget.appendChild(hiddenInput);
      }

      if (propName) {
        const existing2 = formTarget.querySelector(`input[type="hidden"][name="${propName}"]`);
        if (existing2) formTarget.removeChild(existing2);

        const hiddenInput2 = document.createElement("input");
        hiddenInput2.type = "hidden";
        hiddenInput2.name = propName;
        hiddenInput2.value = selectedNames.join(", ");
        hiddenInput2.setAttribute("data-generated-by", this.selName );
        formTarget.appendChild(hiddenInput2);
      }

    } else {
      // SINGLE SELECT
      spanEl.textContent = name;
      this.selectValueEl.setAttribute("data-value", value);
      this.selectValueEl.setAttribute("data-handle", handle);
      if (imgEl) imgEl.src = thumbnail || "";

      // Remove existing hidden inputs
      const existing = formTarget.querySelector(`input[type="hidden"][name="${inputName}"]`);
      if (existing) formTarget.removeChild(existing);

      const hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = inputName;
      hiddenInput.value = value;
      formTarget.appendChild(hiddenInput);

      if (propName) {
        const existing2 = formTarget.querySelector(`input[type="hidden"][name="${propName}"]`);
        if (existing2) formTarget.removeChild(existing2);

        const hiddenInput2 = document.createElement("input");
        hiddenInput2.type = "hidden";
        hiddenInput2.name = propName;
        hiddenInput2.value = name;
        formTarget.appendChild(hiddenInput2);
      }

      this.selectEl?.classList.remove("open");
      this.handlePreview();
    }

    // Mark item as selected
    let isSelectedFlag = item.closest("[data-is-selected]")?.dataset.isSelected;
    if (isSelectedFlag === "false") { item.closest("[data-is-selected]")?.setAttribute("data-is-selected", "true") }

    let name_id = formTarget.querySelector(`input[name="id"]`);
    if (name_id) { name_id.name = "items[99][id]" }

    this.handleOptionSelected(item);
  }

  handlePreview(){
    if(this.selName !== 'custom-select-zodiac' ) return;

    let parent = this.selectValueEl.closest(`div[data-prds]`);
    // console.log('handlePreview parent',parent);
    
    let zEls = parent.querySelectorAll(`div[data-zodiac]`);
    let eVals = [];

    if(zEls.length > 1 )
    zEls.forEach(e => {
      let val = e.querySelector('.js-select-value').dataset.handle;
      if(val){ eVals.push(val.toLowerCase()) }
    })

    if(eVals.length == 2){ 
      // console.log('eVals true', eVals);
      let zPreview = parent.querySelector(`div[data-zodiac-preview]`);      
      let src = zPreview.querySelector('img').dataset.src;
      let newSrc = `${src}${eVals.join("-")}.png`;
      zPreview.style.display = 'flex';
      zPreview.querySelector('img').src = newSrc;
      zPreview.querySelector('img').classList.remove('svg-loader');
    }
    else{ console.warn('eVals false') }
  }

  resetMultiSelect(e = null) {
    e && e.stopPropagation(); // prevent dropdown toggle

    const spanEl = this.selectValueEl.querySelector("span");
    const imgEl = this.selectValueEl.querySelector("img");
    const formTarget = this.closest(".product__blocks")?.querySelector(".product-form form");
    const propName = this.selectValueEl.dataset.propName;
    const name = this.selectValueEl.dataset.name;
    const dataPWrapper = this.closest("[data-p]");
    const dataP = parseInt(dataPWrapper?.getAttribute("data-p")) ;

    if (!formTarget) return;

    const placeholder = this.selectValueEl.dataset.placeholder || "Select";
    spanEl.textContent = placeholder;

    if (imgEl) imgEl.style.display = "inline-block";
    if (this.resetBtn) this.resetBtn.style.display = "none";

    // Remove hidden inputs
    if(dataP != 0){
      const existingMultiInputs = formTarget.querySelectorAll( `input[type="hidden"][name^="items["][data-generated-by="${this.selName}"]` );
      existingMultiInputs.forEach((i) => i.remove());
    }else{
      const existingMultiInputs = formTarget.querySelector( `input[type="hidden"][name="${name}"][data-generated-by="${this.selName}"]` );
      existingMultiInputs.remove();
    }

    if(propName){
      const existing2 = formTarget.querySelector(`input[type="hidden"][name="${propName}"][data-generated-by="${this.selName}"]`);
      if (existing2) formTarget.removeChild(existing2);
    }

    // Reset is-selected
    this.optionEls.forEach(opt => {
      const container = opt.closest('[data-is-selected]');
      if (container) container.setAttribute('data-is-selected', 'false');
    });
  }

  handleOptionSelected(item) {}
}

class CustomSelectZodiac extends CustomSelect {
  constructor() {
    super();
    this.selName = 'custom-select-zodiac';
    this.isMultiSelect = this.closest('[data-p]').dataset.multiSelect;
  }
  handleOptionSelected(item) {
    document.dispatchEvent(new CustomEvent("zodiacChange", {
      detail: {
        item,
      },
    }));
  }
}
customElements.define("custom-select-zodiac", CustomSelectZodiac);

class CustomSelectBirthstone extends CustomSelect {
  constructor() {
    super();
    this.isMultiSelect = true;
    this.selName = 'custom-select-birth';
  }
  handleOptionSelected(item) {
    document.dispatchEvent(new CustomEvent("birthstoneChange", {
      detail: { item },
    }));
  }
}
customElements.define("custom-birthstone-select", CustomSelectBirthstone);


function transformItem0To99(formElement) {
  if (!formElement || !(formElement instanceof HTMLFormElement)) return;

  // ✅ STEP 0: Move existing items[99][id] to end if it exists
  // const existing99 = formElement.querySelector('input[name="items[99][id]"]');
  // if (existing99) {
  //   formElement.appendChild(existing99); // Move to end
  // }

  const inputs99 = formElement.querySelectorAll('input[name^="items[99]"]');
  inputs99.forEach(input => {
    formElement.appendChild(input); // Move each matching input to the end
  });

  // ✅ STEP 1: Find and transform `items[0][id]` to `items[99][id]`
  const inputs = Array.from(formElement.querySelectorAll('input[name^="items[0]"]'));
  const idInputIndex = inputs.findIndex(input => input.name === 'items[0][id]');

  if (idInputIndex !== -1) {
    const idInput = inputs[idInputIndex];

    // Clone and modify name
    const newInput = idInput.cloneNode(true);
    newInput.name = newInput.name.replace('items[0]', 'items[99]');

    // Remove old input and append new one
    idInput.remove();
    formElement.appendChild(newInput);

    // Remove this from inputs array to avoid duplicate rename
    inputs.splice(idInputIndex, 1);
  }

  // ✅ STEP 2: Rename remaining `items[0][...]` to `items[99][...]`
  inputs.forEach(input => {
    input.name = input.name.replace('items[0]', 'items[99]');
  });
}
function addProductKeysWithTimestamp(form) {
  let timestamp = Date.now();
  const indexSet = new Set();
  
  const existingKeys = form.querySelectorAll('input[name$="[_product_key]"]');
  // console.warn('existingKeys',existingKeys);
  existingKeys.forEach(input => {form.removeChild(input)}); //console.warn(input,input.target);
  
  const allInputs = form.querySelectorAll('input[name^="items["]');
  allInputs.forEach(input => {
    const match = input.name.match(/^items\[(\d+)\]/);
    if (match) { indexSet.add(match[1]); }
  });

  indexSet.forEach(i => {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = `items[${i}][properties][_product_key]`;
    hiddenInput.value = timestamp;
    form.appendChild(hiddenInput);
  });
}
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}
function scrollToNewPrddOptsWithOffset() {
  const element = document.querySelector(".new_prdd_opts");
  if (element) {
    const topOffset = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({
      top: topOffset,
      behavior: "smooth"
    });
  }
}


class CustomDatePicker {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    if(this.container){
      this.daySelect = this.container.querySelector('#daySelect');
      this.monthSelect = this.container.querySelector('#monthSelect');
      this.yearSelect = this.container.querySelector('#yearSelect');
      this.formTarget = this.container.closest(".product__blocks")?.querySelector(".product-form form");
      this.inputName = this.container.dataset.name;
      this.init();
    }
  }

  init() {
    this.populateDays();
    this.populateMonths();
    this.populateYears();

    this.setDefaultDate();
    this.updateDataValue();

    this.daySelect.addEventListener('change', () => this.updateDataValue());
    this.monthSelect.addEventListener('change', () => this.updateDataValue());
    this.yearSelect.addEventListener('change', () => this.updateDataValue());
  }

  populateDays() {
    for (let i = 1; i <= 31; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      this.daySelect.appendChild(option);
    }
  }

  populateMonths() {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    months.forEach((month, index) => {
      const option = document.createElement('option');
      option.value = index + 1;
      option.textContent = month;
      this.monthSelect.appendChild(option);
    });
  }

  populateYears() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 60; i <= currentYear + 20; i++) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      this.yearSelect.appendChild(option);
    }
  }

  setDefaultDate(date = new Date()) {
    this.daySelect.value = date.getDate();
    this.monthSelect.value = date.getMonth() + 1;
    this.yearSelect.value = date.getFullYear();
  }

  updateDataValue() {
    const day = parseInt(this.daySelect.value);
    const monthIndex = parseInt(this.monthSelect.value) - 1;
    const year = this.yearSelect.value;

    const shortMonths = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const formatted = `${day} ${shortMonths[monthIndex]}, ${year}`;

    this.container.setAttribute('data-value', formatted);
    this.updateHiddenInput(this.formTarget, this.inputName, formatted);

    let isSelectedFlag = this.container.closest("[data-is-selected]")?.dataset.isSelected;
    if (isSelectedFlag === "false") { this.container.closest("[data-is-selected]")?.setAttribute("data-is-selected", "true") }
  }

  updateHiddenInput(formTarget, inputName, value) {
    const existing = formTarget.querySelector(`input[type="hidden"][name="${inputName}"]`);
    if (existing) formTarget.removeChild(existing);

    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = inputName;
    hiddenInput.value = value;
    formTarget.appendChild(hiddenInput);
  }

  getDate() {
    const day = this.daySelect.value;
    const month = this.monthSelect.value;
    const year = this.yearSelect.value;
    return new Date(year, month - 1, day);
  }
}
const datePicker = new CustomDatePicker('customDatePicker');


// Disc options js --- begin
const disc_parent = document.getElementById('disc-opts');
const discCount = disc_parent?.querySelector('#discCount');
if(disc_parent && discCount){
  const customizationFields = disc_parent.querySelector('#customizationFields');
  const targetContainer = disc_parent.closest('.product__blocks').querySelector('.product-form form');
  
  const FREE_VARIANT_ID = discCount.dataset.freeVar;
  const PAID_VARIANT_ID = discCount.dataset.paidVar;
  
  // const zodiacOptions = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];
  // const birthflowerOptions = ["Carnation", "Violet", "Daffodil", "Daisy", "Lily", "Rose", "Larkspur", "Gladiolus", "Aster", "Marigold", "Chrysanthemum", "Poinsettia"];
  // const symbolOptions = ["Heart", "Star", "Moon", "Sun", "Infinity", "Anchor", "Feather", "Tree", "Mountain", "Wave", "Arrow", "Paw", "Wings"];
  
  discCount.addEventListener('change', renderFields);
  
  function renderFields() {
    customizationFields.innerHTML = '';
    const count = parseInt(discCount.value);
  
    for (let i = 0; i < count; i++) {
      const wrapper = document.createElement('div');
      wrapper.className = 'disc-block';
      wrapper.dataset.index = i;
  
      wrapper.innerHTML = `
        <h4>${discIndividualLabel} ${i + 1}</h4>
        <label>${discTypeLabel}</label>
        <select class="type-select">
          <option value="" disabled selected>-- Select --</option>
          <option value="${discTypeOptions[0]}">${discTypeOptions[0]}</option>
          <option value="${discTypeOptions[1]}">${discTypeOptions[1]}</option>
          <option value="${discTypeOptions[2]}">${discTypeOptions[2]}</option>
          <option value="${discTypeOptions[3]}">${discTypeOptions[3]}</option>
        </select>
        <div class="value-field"></div>
      `;
  
      customizationFields.appendChild(wrapper);
  
      wrapper.querySelector('.type-select').addEventListener('change', (e) => {
        renderValueInput(wrapper, e.target.value);
        updateHiddenInputs(targetContainer, 1);
      });
    }
  }

  function setupDiscPreviewSync() {
    const previewImages = disc_parent.querySelectorAll('#discPreview .disc-preview');

    // Update discPreview visibility when discCount changes
    discCount.addEventListener('change', () => {
      const count = parseInt(discCount.value);
      previewImages.forEach((preview, i) => {
        preview.style.display = (i < count) ? 'flex' : 'none';
        preview.querySelector('img').src = '';
      });
    });

    // Observe changes on customization fields using event delegation
    customizationFields.addEventListener('change', (e) => {
      if (e.target.classList.contains('type-select')) {
        const discBlock = e.target.closest('.disc-block');
        const index = parseInt(discBlock.dataset.index);
        const selectedType = e.target.value;

        const previewImage = disc_parent.querySelector(`.disc-preview[data-d-index="${index + 1}"] img`);
        
        if (!previewImage) return;

        if (selectedType === discTypeOptions[0]) {
          // Watch input for live updates
          const input = discBlock.querySelector('input[type="text"]');
          if (input) {
            input.addEventListener('input', () => {
              const maxLength = input.getAttribute('maxlength') || 7;              
              const maxFontSize = 42; 
              const minFontSize = 18; 
              
              const value = input.value.trim();
              const length = Math.min(value.length, maxLength);
              
              const fontSize = maxFontSize - ((length - 1) / (maxLength - 1)) * (maxFontSize - minFontSize);
              
              const parentDiv = previewImage.closest('.disc-preview');
              previewImage.style.display = 'none';

              parentDiv.setAttribute('data-text', value);
              
              parentDiv.style.setProperty('--dynamic-font-size', fontSize + 'px');

            });

          }
        }
      }
    });

    // Handle value button clicks (e.g. zodiac, symbols)
    customizationFields.addEventListener('click', (e) => {
      if (e.target.tagName === 'BUTTON' && e.target.closest('.value-field')) {
        const btn = e.target;
        const discBlock = btn.closest('.disc-block');
        const index = parseInt(discBlock.dataset.index);
        const src = btn.dataset.src;

        const previewImage = disc_parent.querySelector(`.disc-preview[data-d-index="${index + 1}"] img`);
        if (previewImage) {
          const parentDiv = previewImage.closest('.disc-preview');
          previewImage.style.display = 'block';
          previewImage.src = src;
          previewImage.alt = btn.textContent || '';
          parentDiv.removeAttribute('data-text');
        }

        // Remove "selected" class from all buttons in this value-field
        btn.closest('.value-field').querySelectorAll('button').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
      }
    });
  }
  
  function renderValueInput(wrapper, type) {
    const valueField = wrapper.querySelector('.value-field');
    valueField.innerHTML = '';

    if (type === discTypeOptions[0]) {
      const input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'Enter initials or name';
      input.setAttribute('maxlength', 7);
      input.addEventListener('input', () => updateHiddenInputs(targetContainer, 1));
      valueField.appendChild(input);
    } else {
      const options = (type === discTypeOptions[1] ) ? zodiacOptions : (type === discTypeOptions[2] ) ? birthflowerOptions : symbolOptions;
      options.forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        // btn.textContent = opt.label;
        btn.dataset.src = opt.image;
        btn.style.backgroundImage = `url(${opt.image})`;
        btn.setAttribute('btn_label', opt.label);
        btn.addEventListener('click', () => {
          valueField.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          updateHiddenInputs(targetContainer, 1, true);
        });
        valueField.appendChild(btn);
      });
    }
  }
  
  function updateHiddenInputs(targetElement, startIndex = 0, isValClick = false) {
    const blocks = document.querySelectorAll('.disc-block');
  
    blocks.forEach((block, i) => {

      const realIndex = startIndex + i;

      const type = block.querySelector('.type-select').value;
      if (!type) return;
  
      let value = '';
      if (type === discTypeOptions[0]) {
        value = block.querySelector('input')?.value?.trim();
      } else {
        const selectedBtn = block.querySelector('.value-field .selected');
        const btnLabel = selectedBtn?.getAttribute('btn_label');
        // value = selectedBtn?.textContent || selectedBtn?.getAttribute('btn_label') || '';
        value = typeof btnLabel !== 'undefined' ? btnLabel : '';
      }
      
      if (!value) return;
  
      const variantId = (i === 0) ? FREE_VARIANT_ID : PAID_VARIANT_ID;
  
      // Remove existing inputs for this disc index
      // [...targetElement.querySelectorAll(`[data-disc-index="${realIndex}"]`)].forEach(el => el.remove());
      
  
      // Hidden Input: Variant ID
      if (targetElement.querySelector(`[data-disc-index-var="${realIndex}"]`)){
        targetElement.querySelector(`[data-disc-index-var="${realIndex}"]`).value = variantId;
      }
      else{
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = `items[${realIndex}][id]`;
        idInput.value = variantId;
        idInput.setAttribute('data-generated-by', 'custom-disc');
        idInput.setAttribute('data-disc-index', realIndex);
        idInput.setAttribute('data-disc-index-var', realIndex);
        targetElement.appendChild(idInput);
      }

      // Hidden Input: Property
      if (targetElement.querySelector(`[data-disc-index-var-prop="${realIndex}"]`)){
        targetElement.querySelector(`[data-disc-index-var-prop="${realIndex}"]`).value = value;
      }
      else{
        const propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = `items[${realIndex}][properties][${type}]`;
        propInput.value = value;
        propInput.setAttribute('data-generated-by', 'custom-disc');
        propInput.setAttribute('data-disc-index', realIndex);
        propInput.setAttribute('data-disc-index-var-prop', realIndex);
        targetElement.appendChild(propInput);
      }

      if (targetElement.querySelector(`[data-disc-index-main-prd="${realIndex}"]`)){
        targetElement.querySelector(`[data-disc-index-main-prd="${realIndex}"]`).name = `items[99][properties][Disc - ${realIndex} : ${type}]`;
        targetElement.querySelector(`[data-disc-index-main-prd="${realIndex}"]`).value = value;
      }
      else{
        const mainPropInput = document.createElement('input');
        mainPropInput.type = 'hidden';
        mainPropInput.name = `items[99][properties][Disc - ${realIndex} : ${type}]`;
        mainPropInput.value = value;
        mainPropInput.setAttribute('data-disc-index-main-prd', realIndex);
        targetElement.appendChild(mainPropInput);
      }

    });

    document.querySelector('[name="items[99][properties][Discs]"]')?.remove();

    const mainPropCount = document.createElement('input');
    mainPropCount.type = 'hidden';
    mainPropCount.name = `items[99][properties][Discs]`;
    mainPropCount.value = blocks.length;
    mainPropCount.setAttribute('data-disc-index', blocks.length);
    targetElement.appendChild(mainPropCount);


    // console.log('blocks',blocks);
    
    if(isValClick){
      if(blocks.length > 0){
        const container = discCount.closest('[data-is-selected]');
        if (container) container.setAttribute('data-is-selected', 'true');
      }else{
        const container = discCount.closest('[data-is-selected]');
        if (container) container.setAttribute('data-is-selected', 'false');
      }
    }

    let name_id = targetElement.querySelector(`input[name="id"]`);
    if(name_id){ name_id.name = 'items[99][id]' }

  }
  
  renderFields();
  setupDiscPreviewSync();
}
// Disc options js ----- End


document.addEventListener('change', (e) => {
  let item = e.target;

  if(item.closest('.one-zodiac-opts')){
    let form = item.closest('.product__blocks').querySelector('.product-form form');
    syncHiddenInput(item, form);
  }
})
document.addEventListener('DOMContentLoaded', () => {
  let zAtcBtn = document.querySelector('.product-form form button.ctm--zodiac-atc-btn');
  // console.log(zAtcBtn);
  
  if(zAtcBtn){ zAtcBtn.type = 'button' }
})
document.addEventListener('click', (e)=> {
  let item = e.target;

  if(item.closest('.ctm--zodiac-atc-btn') && item.closest('.ctm--zodiac-atc-btn').type == 'button'){
    let i = item.closest('.ctm--zodiac-atc-btn');
    let prdOptEl = item.closest('.product__blocks').querySelector('.new_prdd_opts');
    let form = item.closest('.product__blocks').querySelector('.product-form form');
    let steps, isAllValid = true;
    // let prds = parseInt(prdOptEl.dataset.prds);
    
    if(prdOptEl.querySelector('#one-zodiac-opts')){ steps = prdOptEl.querySelectorAll('#one-zodiac-opts .one-zodiac-opts__step') }
    if(prdOptEl.querySelector('#two-zodiac-opts')){ steps = prdOptEl.querySelectorAll('#two-zodiac-opts .two-zodiac-opts__step') }
    if(prdOptEl.querySelector('#roman-numeric-opts')){ steps = prdOptEl.querySelectorAll('#roman-numeric-opts .roman-numeric-opts__step') }
    if(prdOptEl.querySelector('#birthflower-opts')){ steps = prdOptEl.querySelectorAll('#birthflower-opts .birthflower-opts__step') }
    if(prdOptEl.querySelector('#disc-opts')){ steps = prdOptEl.querySelectorAll('#disc-opts .disc-opts__step') }

    addProductKeysWithTimestamp(form)
    
    steps.forEach( (e) => {     
      if(e.dataset.isSelected == 'false'){ 
        let isOptional = e.dataset.optional;
        if(isOptional == 'true'){}
        else if(e.querySelector('input:checked')){ syncHiddenInput(e.querySelector('input:checked'), form)}
        else{ e.classList.add('warning'); isAllValid = false }
      } 
    })

    // !isAllValid && scrollToTop();
    !isAllValid && scrollToNewPrddOptsWithOffset();

    setTimeout(() => { steps.forEach( e => { e.classList.remove('warning') }) }, 2000);

    transformItem0To99(form);

    console.log('isAllValid',isAllValid);
    
    if(isAllValid && steps.length > 0){ i.type = 'submit';i.click();i.type = 'button'; }
    // else{ console.warn('All Values are not Selected') }
  }
})

document.querySelector(".roman-numeric-options .fixed_atc_container .product-form__submit")?.addEventListener('click', scrollToNewPrddOptsWithOffset)

 